<template>
    <div
      ref="animatedElement"
      :class="['animated-element', animationClass]"
    >
      <slot />
    </div>
  </template>
  
  <script>
  export default {
    props: {
      animation: {
        type: String,
        default: "animate__fadeInUp",
      },
    },
    data() {
      return {
        isVisible: false,
        imageLoaded: false,
      };
    },
    computed: {
      animationClass() {
        return this.isVisible ? `animate__animated ${this.animation}` : "";
      },
    },
    methods: {
      onImageLoad() {
        this.imageLoaded = true;
        this.setupObserver(); // 画像がロードされた後にObserverを設定
      },
      setupObserver() {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              this.isVisible = true;
              observer.disconnect(); // 一度だけアニメーションを適用
            }
          },
          { threshold: 0.1 }
        );
  
        observer.observe(this.$refs.animatedElement);
      },
    },
    mounted() {
      const images = this.$refs.animatedElement.querySelectorAll('img');
  
      // 要素内に画像が存在する場合
      if (images.length > 0) {
        let loadedImages = 0;
  
        images.forEach((img) => {
          // 画像が読み込まれた際にカウントアップ
          img.addEventListener('load', () => {
            loadedImages++;
            if (loadedImages === images.length) {
              this.onImageLoad(); // すべての画像が読み込まれたら処理を進める
            }
          });
  
          // すでに画像がキャッシュされている場合
          if (img.complete) {
            loadedImages++;
          }
        });
  
        // すべてキャッシュ済みの場合、即座に処理を進める
        if (loadedImages === images.length) {
          this.onImageLoad();
        }
      } else {
        // 要素内に画像が存在しない場合は即座に処理を進める
        this.imageLoaded = true;
        this.setupObserver();
      }
    },
  };
  </script>
  
  <style>
  .animated-element {
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  }
  
  .animated-element.animate__animated {
    opacity: 1;
  }
  </style>
  